
const ImageGallery = ({ images, className = "content" }) => {
  return (
    <div
      className={`${className} horizontal-gallery`}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    >
      {images.map((image, index) => (
        <img
          key={image.src || image}
          className="gallery"
          src={image.src || image}
          alt={`Artwork ${index + 1}`}
          loading="lazy"
          decoding="async"
          draggable="false"
        />
      ))}
    </div>
  );
};

export default ImageGallery;
